(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.carousel-depth').forEach(container => {
    const track = container.querySelector('.carousel-depth__track');
    if (!track) return;

    const slides = track.querySelectorAll('.carousel-depth__main > *, .carousel-depth__clone > *');
    const setSize = slides.length / 3;
    const prevBtn = container.querySelector('.carousel-depth__button--prev');
    const nextBtn = container.querySelector('.carousel-depth__button--next');

    let isJumping = false;
    let timeoutId;

    const getSetWidth = () => {
      const mainSet = track.querySelector('.carousel-depth__main');
      if (!mainSet) return 0;

      let width = 0;
      let visibleCount = 0;
      const items = mainSet.children;
      for (let i = 0; i < items.length; i++) {
        if (items[i].offsetWidth > 0) {
          width += items[i].offsetWidth;
          visibleCount++;
        }
      }
      const gap = parseFloat(getComputedStyle(track).gap || 16);
      return width + (visibleCount * gap);
    };

    const jumpTo = (scrollPos) => {
      isJumping = true;
      track.setAttribute('data-jumping', 'true');
      
      track.scrollLeft = scrollPos;
      
      // Allow browser to settle before restoring snap and smooth behavior
      setTimeout(() => {
        track.removeAttribute('data-jumping');
        isJumping = false;
      }, 50);
    };

    const initPosition = () => {
      const setW = getSetWidth();
      if (setW > 0) jumpTo(setW);
    };

    const handleScroll = () => {
      if (isJumping) return;
      
      const setW = getSetWidth();
      if (setW <= 0) return;

      const scrollPos = track.scrollLeft;
      
      // We jump when the scroll position leaves the middle set range [setW * 0.8, setW * 2.2]
      // This is much more stable than waiting for the very end.
      if (scrollPos < setW * 0.5) {
        jumpTo(scrollPos + setW);
      } else if (scrollPos > setW * 2.5) {
        jumpTo(scrollPos - setW);
      }
    };

    // IntersectionObserver for scaling effect
    const observerOptions = {
      root: track,
      threshold: 0.6,
      rootMargin: '0px -20% 0px -20%'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.classList.toggle('in-view', entry.isIntersecting);
      });
    }, observerOptions);

    slides.forEach(slide => observer.observe(slide));

    const debouncedScroll = () => {
      if (timeoutId) cancelAnimationFrame(timeoutId);
      timeoutId = requestAnimationFrame(handleScroll);
    };

    track.addEventListener('scroll', debouncedScroll);

    if (prevBtn && nextBtn) {
      const getStep = () => {
        const mainSet = track.querySelector('.carousel-depth__main');
        if (!mainSet) return 300;
        const firstSlide = Array.from(mainSet.children).find(el => el.offsetWidth > 0);
        if (!firstSlide) return 300;
        return firstSlide.offsetWidth + parseFloat(getComputedStyle(track).gap || 16);
      };

      let isScrolling = false;
      const scrollOne = (direction) => {
        if (isScrolling) return;
        isScrolling = true;
        const target = track.scrollLeft + direction * getStep();
        track.scrollLeft = target;
        setTimeout(() => { isScrolling = false; }, 400);
      };

      prevBtn.addEventListener('click', () => scrollOne(-1));
      nextBtn.addEventListener('click', () => scrollOne(1));
    }

    window.addEventListener('resize', () => {
      initPosition();
    });

    // Run init after a short delay to ensure dimensions are ready
    setTimeout(initPosition, 150);
  });
  } catch(e) { console.error(e); }
})();

})();
